import React from 'react';
import { withTranslation } from 'react-i18next';
import ImgIconComp from '../../../../components/imgcomp';
import { type WithTranslation } from '../../../types/common.types';
import { AiLoopProps } from '../../../types/sidePanel.types';

export default withTranslation()(class AiLoopComp extends React.Component<WithTranslation<AiLoopProps>> {
  constructor(props: WithTranslation<AiLoopProps>) {
    super(props);
    this.addLoopMembers = this.addLoopMembers.bind(this);
    this.registerPeopleAutoComplete = this.registerPeopleAutoComplete.bind(this);
  }

  componentDidMount() {
    setTimeout(() => this.registerPeopleAutoComplete(), 100);
  }

  addLoopMembers(actId: any, userId: string, isList = false) {
    const _this = this;
    const aiDetails = this.props.aiDet;
    const aiOwner = aiDetails.owner;
    let useList = "";
    if (isList) {
      $.each(userId, (k, v: any) => {
        const isExistloopMembers = _this.props.aiLoopMembers.find(
          (m: { id: any; }) => m.id == v.id
        );
        if (!isExistloopMembers && aiOwner != v.id) {
          if (useList.length > 0) {
            useList = `${useList}~${v.id}`;
          } else {
            useList = v.id;
          }
        }
      });
    } else {
      const isExistloopMembers = _this.props.aiLoopMembers.find(
        (m: { id: any; }) => m.id == userId
      );
      if (!isExistloopMembers && aiOwner != userId) {
        useList = userId;
      }
    }
    if (useList.length > 0) {
      $.post(
        `${wbConfig.baseUrl}/activity/handleLoopMember`,
        {
          actId,
          memId: useList,
          actType: "add",
          wsBoardView: true
        },
        (data, status) => {
          if (status == "success") {
            $.each(data.data, (k, v) => {
              _this.props.addLoopToStateList(v);
            });
          }
        }
      );
    }
  }

  registerPeopleAutoComplete() {
    const _this = this;
    const aiDetails = this.props.aiDet;
    ($(_this.refs.peopleSearch) as any)
      .autocomplete({
        minLength: 2,
        source(request: { term: any; }, response: (arg0: { label: any; pic: any; email: any; teamName: any; value: any; title: any; userId: string | number | symbol; }[]) => void) {
          const actId = aiDetails.id;
          const aiOwner = aiDetails.owner;
          const teamId = "";
          const usersCurrentlyInLoop = "";
          const usersCurrentlyRemovedFromLoop = "";
          const actionType = "edit";
          const currentOwner = "";
          const isInLoop = "";
          $.ajax({
            url: `${wbConfig.baseUrl}/activity/GetOtherPeopleInLoop`,
            type: "GET",
            dataType: "json",
            data: {
              term: request.term,
              usersInLoop: usersCurrentlyInLoop,
              usersCurrentlyRemovedFromLoop,
              act_id: actId,
              actionType,
              currentOwner,
              isInLoop,
              teamId
            }
          })
            .done(data => {
              response(
                $.map(data, (value, key) => {
                  if (aiOwner != key) {
                    return {
                      label: value.name,
                      pic: value.pic,
                      email: value.email,
                      teamName: value.teamName,
                      value: value.value,
                      title: value.title == null ? "" : value.title,
                      userId: key
                    };
                  }
                })
              );
            })
            .fail(() => {
              response([]);
            });
        },
        select(event: any, ui: { item: { email?: any; pic?: any; label?: any; value?: any; teamName?: any; userId?: any; }; }) {
          const userEmail = ui.item.email;
          const { teamName } = ui.item;
          const { userId } = ui.item;
          const userPic = ui.item.pic;
          const userName = ui.item.label;
          const userFirstName = ui.item.value;

          $(_this.refs.peopleSearch).val("");
          // userId will be 00 if there are no suggestions and a default msg is returned from server.
          if (userId != "00") {
            if (userId.indexOf("team_") > -1) {
              const teamId = userId.replace("team_", "");
              $.post(
                wbConfig.baseUrl + '/team/getTeamUserDetails',
                { teamId, allUser: 1 },
                (data, status) => {
                  if (status == "success") {
                    const res = JSON.parse(data);
                    const memDet = res.inviteeList;
                    if (typeof memDet !== "undefined") {
                      _this.addLoopMembers(aiDetails.id, memDet, true);
                    }
                  } else {
                    return false;
                  }
                }
              );
            } else {
              _this.addLoopMembers(aiDetails.id, userId);
            }
          }
          return false;
        },
        open(event: any, ui: any) {
          $(this)
            .data("ui-autocomplete")
            .menu.element.addClass("board-loop-autocomplete").css({ zIndex: 120});
        }
      })
      .data("ui-autocomplete")._renderItem = function (ul: string | Element | JQuery<HTMLElement> | DocumentFragment | (Element | DocumentFragment)[], item: { pic: string; userId: string; label: string; title: string; }) {
        let userImageDiv = "";
        if (item.pic != "") {
          const { userId } = item;
          userImageDiv = `<div style="display: table-cell; padding-right: 10px; width: 22%;min-height:30px;"><img class="fitProfileImage aiEditCommentsUsrImg roundFramePhoto ${
            userId.indexOf("team_") > -1 ? "teamIcon" : ""
            }" src="${item.pic}"></img></div>`;
        }

        return $('<li class="loopAutoSuggest"></li>')
          .data("item.autocomplete", item)
          .append(
            `<a><div style="width: 100%; display: table;" class="tabLayFix" title="${item.label}">${userImageDiv}<div style="display: table-cell; vertical-align: top; width: 78%; padding-left: 5px;"><div class="truncateText" style="width: 98%">${item.label}</div><div class="truncateText" style="width: 98%">${item.title}</div></div></div></a>`
          )
          .appendTo(ul);
      };
  }

  render() {
    const { t } = this.props;
    return (
      <div className="wsBoardAiLoopWrapper">
        <div className="wsBoardAddLoopDiv pL10">
          <input
            type="text"
            className="wsBoardAddLoopBox"
            ref="peopleSearch"
            placeholder={t("Search for people or team name")}
          />
        </div>
        <div className="wsBoardLoopListDiv">
          {this.props.aiLoopMembers != null &&
            Object.keys(this.props.aiLoopMembers).length
            ? Object.keys(this.props.aiLoopMembers).map((item, index) => (
              <LoopListWrapper
                key={this.props.aiLoopMembers[item].id}
                type={this.props.v1Loop ? "popup" : "sidePanel"}
                loopDet={this.props.aiLoopMembers[item]}
                removeItemFromList={this.props.removeItemFromList}
                loopRemoveAccess={this.props.loopRemoveAccess}
              />
            ))
            : ""}
        </div>
      </div>
    );
  }
});

const LoopListWrapper = (props: {
  type: string;
  loopDet: { 
    picture: any; 
    firstname: any; 
    lastname: any; 
    id: any; 
  };
  loopRemoveAccess: any; 
  removeItemFromList: (arg0: string, arg1: any, arg2: boolean) => void;
}) => {
  if (props.type === "sidePanel") {
    return <WsBoardLoopListComp {...props} />
  } else {
    return <WsBoardLoopListCompV1 {...props} />
  }
}

// ai-detail loop list
const WsBoardLoopListComp = function (props: { loopDet: { picture: any; firstname: any; lastname: any; id: any; }; loopRemoveAccess: any; removeItemFromList: (arg0: string, arg1: any, arg2: boolean) => void; }) {
  return (
    <div className="wsBoardLoopDiv displayTable w100">
      <div className="displayRow">
        <div className="displayCell wsBoardLoopUserImg">
          <ImgIconComp
            class="roundFramePhoto vAlignM fitProfileImage"
            srcUrl={props.loopDet.picture}
            width="30"
            height="30"
          />
        </div>
        <div className="displayCell wsBoardLoopUser">
          {`${props.loopDet.firstname} ${props.loopDet.lastname}`}
        </div>
        <div
          className="displayCell wsBoardLoopCloseDiv clickable"
          data-perm-value={props.loopRemoveAccess}
          onClick={() =>
            props.removeItemFromList("aiLoopMembers", props.loopDet.id, true)
          }
        >
          <ImgIconComp id="close" width="8" height="8" />
        </div>
      </div>
    </div>
  );
};

const WsBoardLoopListCompV1 = function (props: {
  loopDet: { 
    picture: any; 
    firstname: any; 
    lastname: any;
    id: any; 
  }; 
  loopRemoveAccess: any; 
  removeItemFromList: (arg0: string, arg1: any, arg2: boolean) => void; 
}) {


  return (
    <div className="in-the-loop-member-container">
      <div className="itl-user-data">
        <ImgIconComp
          class="roundFramePhoto vAlignM fitProfileImage"
          srcUrl={props.loopDet.picture}
          width="38"
          height="36"
        />
        <div 
          className="itl-user-name"
        >
          {`${props.loopDet.firstname} ${props.loopDet.lastname}`}
        </div>
      </div>
      <img
        src="/wb/images/ai-v1-assets/close.png"
        onClick={() => props.removeItemFromList("aiLoopMembers", props.loopDet.id, true)}
      />
    </div>
  )
}